import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AbstractItem } from '@business/base/abstract-item';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { BusinessBookService } from '@services/webFeeder/sckt-business-book.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { QuoteService } from '@services/webFeeder/sckt-quotes.service';
import { TokenService } from '@services/webFeeder/token.service';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AppUtils } from '@utils/app.utils';
import { Constants } from '@utils/constants';
import { NotificationsService } from 'angular2-notifications';
import { Subscription , of } from 'rxjs';
import { AuthServer } from '@services/auth-server.service';
import { MarketEnum } from '@model/enum/market.enum';

@Component({
  selector: Constants.WINDOW_NAME_TIMES_TRADES,
  templateUrl: './times-trades.component.html'
})
export class TimesTradesComponent extends AbstractItem implements OnInit, OnDestroy { // DoCheck, OnChanges

  componentName = Constants.TITLE_CARD_TIMES_TRADES;
  symbol = '';
  tickSize = 2;
  rowOffersData: any[];
  rowPriceData: any[];
  imgName: any;
  loadingImgName: boolean;
  newWindow = false;
  private subscriptionBusinessBook: Subscription;
  private subscriptionQuote: Subscription;
  messageQuote = new MessageQuote();
  // classPressure: string;
  classRowCenter: string;
  windowActive: any;
  override dialog: MatDialog;
  protected override workspaceService: WorkspaceNewService;
  style = 0;
  last;
  loading: boolean;
  pressureBarPercentageLeft: string;
  pressureBarPercentageRight: string;
  highOptimized = '';
  lowOptimized = '';
  quantityOptimized = '';
  indiceFuture: boolean;
  closedMarketmsg = Constants.CLOSED_MARKET_MESSAGE;
  msgEmpty = Constants.EMPTY_MESSAGE;
  msgNoData = Constants.WORKSPACE_MSG018;
  marketClosed = false;
  showExpandCard = this.configService.getShowExpandCard(this.componentName);
  hiddenInvalidActive: boolean;
  company: string;
  lastTrade: string;

  @Input() override data: any;
  tooltiphover: boolean;
  isSubscribeBusinessBook: boolean;
  showEmpty: boolean;
  auctionHammer: boolean;
  showVariation: boolean;
  isUpdateOnDemand: boolean;
  priceTheory: number;
  varTheory: string;
  timeToOpen: string;
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;
  firstLoad: boolean;
  oldSymbolTemp;

  constructor(
    private businessBookService: BusinessBookService,
    private quoteService: QuoteService,
    private route: ActivatedRoute,
    workspaceService: WorkspaceNewService,
    itemService: AbstractItemService,
    dialog: MatDialog,
    public _NotificationService: NotificationsService,
    private _authServer: AuthServer,
    private configService: ConfigService,
    private datePipe: DatePipe
  ) {
    super(workspaceService, dialog, itemService);
    this.workspaceService = workspaceService;
    this.dialog = dialog;
    this.tooltiphover = false;
    this.indiceFuture = false;
  }

  ngOnInit() {
    if (this.data && this.data.symbol) {
      this.symbol = this.data.symbol;
      this.firstLoad = true;
      this.subscribeQuote(this.data.symbol);
    } else {
      this.route.queryParams.subscribe(params => {
        if (params['symbol']) {
          this.newWindow = true;
          this.symbol = params['symbol'];
          setTimeout(() => {
            this.subscribeQuote(this.symbol);
          }, 2000);
        }
      });
    }
  }

  ngOnDestroy() {
    this.closeSheet();
    if (this.symbol !== '') {
      if (this.businessBookService) {
        this.businessBookService.unsubscribeBook(this.symbol, this.componentName);
      }
    }
    if (this.symbol !== '') {
      if (this.quoteService) {
        this.quoteService.unsubscribeQuote(this.symbol, Constants.WINDOW_NAME_TIMES_TRADES);
      }
    }
    if (this.subscriptionBusinessBook) {
      this.subscriptionBusinessBook.unsubscribe();
    }
    if (this.subscriptionQuote) {
      this.subscriptionQuote.unsubscribe();
    }
  }

  selectAsset(event) {
    if (this.symbol && event && event.symbol) {
      if (this.symbol.toLowerCase() === event.symbol.toLowerCase()) {
        return;
      }
    }
    if (event.symbol === '') {
      if (this.oldSymbolTemp !== undefined) {
        super.updateOnDemand(this.symbol, event.symbol, false);
      }
      this.company = '';
      this.symbol = '';
      this.oldSymbolTemp = undefined;
    }
    this.subscribeQuote(event.symbol);
  }

  subscribeQuote(symbol: string) {
    if (symbol) {
      symbol = AppUtils.trimStart(symbol);
      symbol = symbol.toLowerCase();
      this.oldSymbolTemp = this.symbol ? this.symbol : '';
      if (symbol && symbol.toLowerCase() === 'invalid' || symbol === '') {
        this.imgName = '';
        this.symbol = '';
        this.hiddenInvalidActive = false;
        return;
      }
      if (this.symbol && symbol && this.subscriptionQuote !== undefined && this.symbol.toLowerCase() === symbol.toLowerCase()) {
        return;
      }
      if (this.symbol && symbol && this.symbol !== '' && this.symbol.toLowerCase() !== symbol) {
        // if (this.data && super.validateOnlyOneAssetAssigned(symbol, this.data.type, this.data.workspaceId) === true) {
        //   this._NotificationService.error('Erro', Constants.WORKSPACE_MSG015);
        //   this.symbol = '';
        //   super.updateOnDemand(this.oldSymbolTemp, this.symbol, true);
        //   setTimeout(() => {
        //     this.symbol = this.oldSymbolTemp;
        //   }, 0);
        //   return;
        // }

        this.quoteService.unsubscribeQuote(this.symbol, this.componentName);
        if (this.subscriptionQuote) {
          this.subscriptionQuote.unsubscribe();
        }
      }
      this.messageQuote = new MessageQuote();
      this.rowOffersData = [];
      this.last = 0;
      this.loading = true;
      const oldSymbol = this.symbol;
      this.symbol = symbol;
      this.quoteService.subscribeQuote(symbol, this.componentName);
      this.isSubscribeBusinessBook = false;
      this.isUpdateOnDemand = false;
      this.imgName = '';
      this.loadingImgName = true;
      var _TimesTradesInstance = this;
      this.subscriptionQuote = this.quoteService.messagesQuote
        .subscribe((msg: MessageQuote) => {
          if (msg && msg.errorMessage && msg.symbol === this.symbol) {
            this.hiddenInvalidActive = true;
            this.symbol = null;
            this.company = null;
            if (Constants.WORKSPACE_MSG030 && msg.symbol && _TimesTradesInstance.firstLoad) {
              _TimesTradesInstance.firstLoad = false;
              const messageShow = Constants.WORKSPACE_MSG030.replace('{{quote}}', msg.symbol.toUpperCase()).replace('{{card}}', this.componentName);
              this._NotificationService.warn('', messageShow);
            }
            this.quoteService.unsubscribeQuote(msg.symbol.toLowerCase(), this.componentName);
          } else if (msg !== undefined && msg.symbol != null && msg.symbol === this.symbol) {
            _TimesTradesInstance.firstLoad = false;
            if (this.loadingImgName) {
              this.imgName = './assets/images/symbols/' + AppUtils.getImageSymbol(this.symbol, msg.marketType).toUpperCase() + '.PNG';
              this.loadingImgName = false;
            }
            this.tickSize = msg.marketType !== MarketEnum.BITCOIN
              ? Number(msg.tickSize)
              : 3;
            if (!this.isUpdateOnDemand) {
              this.isUpdateOnDemand = true;
              if (this.data) {
                this.data.symbol = this.symbol;
                super.updateOnDemand(oldSymbol, this.symbol);
              }
            }
            if (!this.isSubscribeBusinessBook) {
              this.isSubscribeBusinessBook = true;
              this.subscrobeBusinessBook(msg.symbol, msg.marketType);
            }
            this.hiddenInvalidActive = false;
            this.last = this.messageQuote.lastTrade;
            this.messageQuote = msg;
            if (this.messageQuote.lastTrade
              && (this.messageQuote.lastTrade.toString() === '-' || this.messageQuote.lastTrade.toString() === '0,00' || this.messageQuote.lastTrade.toString() === '0')) {
              this.showVariation = false;
              this.messageQuote.lastTrade = this.messageQuote.previous;
            }
            this.quantityOptimized = AppUtils.getNumberOtimized(this.messageQuote.quantity, 0);
            if (this.messageQuote.high) {
              this.highOptimized = this.messageQuote.high.toString();
            }
            if (this.messageQuote.low) {
              this.lowOptimized = this.messageQuote.low.toString();
            }
            if (this.messageQuote.symbol.indexOf('win') === 0 || this.messageQuote.symbol.indexOf('wdo') === 0 ||
              this.messageQuote.symbol.indexOf('dol') === 0 || msg.symbol.toLowerCase().indexOf('ind') === 0) {
              this.indiceFuture = true;
            } else {
              this.indiceFuture = false;
            }
            if (msg.theoryPrice && (msg.theoryPrice > 0 || (msg.theoryPrice.toString() !== '-' && Number(msg.theoryPrice.toString().replace(',', '.'))))) {
              this.priceTheory = AppUtils.convertBrCurrencyToNumber(msg.theoryPrice.toString(), ',');
              this.auctionHammer = true;
              this.timeToOpen = msg.timeToOpen;
              let previousConst = 0;
              if (msg.previous && msg.previous.toString() !== '-') {
                previousConst = AppUtils.convertBrCurrencyToNumber(msg.previous.toString(), ',');
              }
              if (this.priceTheory > 0 && previousConst > 0) {
                let varTheoryTemp = ((this.priceTheory / previousConst) - 1) * 100;
                if (varTheoryTemp !== 0) {
                  varTheoryTemp = Number(Number(varTheoryTemp).toFixed(2));
                  this.varTheory = AppUtils.convertNumberToCurrency(varTheoryTemp, null, '');
                }
              }
            } else {
              this.priceTheory = 0;
              this.varTheory = null;
              this.timeToOpen = null;
              this.auctionHammer = false;
            }
            if (this.messageQuote.lastTrade) {
              const lastTradeNumber = AppUtils.convertFormattedNumberToNumber(this.messageQuote.lastTrade);
              this.lastTrade = AppUtils.numberToCurrency(lastTradeNumber, this.tickSize);
              if (this.messageQuote.lastTrade < this.last) {
                this.style = 2;
              }
              if (this.messageQuote.lastTrade > this.last) {
                this.style = 1;
              }
            }
            if (this.messageQuote.dateLastNegotiation) {
              const today = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
              if (today === this.messageQuote.dateLastNegotiation) {
                this.showVariation = true;
              } else {
                this.showVariation = false;
              }
            } else {
              this.showVariation = true;
            }
            if (msg.description && msg.description !== '' && this.messageQuote.marketType === Constants.MARKET_CODE_BOVESPA) {
              this.company = this.messageQuote.description + ' ' + this.messageQuote.classification;
            } else {
              this.company = this.messageQuote.description;
            }
          }
          this.messageQuote.coinVariation = this.messageQuote.coinVariation && this.messageQuote.coinVariation.toString() !== '-'
            ? Number(this.messageQuote.coinVariation.toString().replace(',', '.')) : 0.0;
          this.loading = false;
        });
    }
  }

  private subscrobeBusinessBook(symbol: string, marketType: number) {
    if (this.symbol !== '') {
      this.businessBookService.unsubscribeBook(this.symbol, this.componentName);
      if (this.subscriptionBusinessBook) {
        this.subscriptionBusinessBook.unsubscribe();
      }
    }
    if (symbol && (marketType === 1 || marketType === 3)) {
      this.businessBookService.subscribeBook(symbol, this.componentName);
      this.symbol = symbol;
      this.showEmpty = false;
      this.subscriptionBusinessBook = this.businessBookService.messagesBusinessBook
        .subscribe((msg: any) => {
          if (msg !== undefined && msg.symbol !== undefined && msg.symbol !== null && msg.symbol === this.symbol) {
            this.rowOffersData = [];
            let dateL;
            let aggressor;
            let aggressorClass;
            if (msg.quoteTrade.L.length > 0) {
              for (let i = msg.quoteTrade.L.length - 1; i >= 0; i--) {
                if (msg.quoteTrade.L[i]) {
                  switch (msg.quoteTrade.L[i].CDA) {
                    case 'A':
                      aggressor = 'C';
                      aggressorClass = 'buy-aggressor';
                      break;
                    case 'V':
                      aggressor = 'V';
                      aggressorClass = 'sell-aggressor';
                      break;
                    case 'I':
                      aggressor = 'I';
                      aggressorClass = 'rlp-aggressor';
                      break;
                    case 'R':
                      aggressor = 'R';
                      aggressorClass = 'rlp-aggressor';
                      break;
                    case 'D':
                      aggressor = 'D';
                      aggressorClass = 'direct-agressor';
                      break;
                    default:
                      aggressor = '';
                      aggressorClass = '';
                      break;
                  }
                  if (msg.quoteTrade.L[i]) {
                    dateL = msg.quoteTrade.L[i].T;
                  }
                  const data = {
                    time: new Date(dateL),
                    price: AppUtils.convertNumberToCurrency(msg.quoteTrade.L[i].P, this.tickSize),
                    quantity: AppUtils.getNumberOtimized(msg.quoteTrade.L[i].QT).replace(',', '.'),
                    buy: this._authServer.iQuote.getPlayerName(msg.quoteTrade.L[i].PCB) || msg.quoteTrade.L[i].PCB,
                    buy_short: this._authServer.iQuote.getPlayerName(msg.quoteTrade.L[i].PCB) || msg.quoteTrade.L[i].PCB,
                    buyId: msg.quoteTrade.L[i].PCB,
                    sell: this._authServer.iQuote.getPlayerName(msg.quoteTrade.L[i].PCL) || msg.quoteTrade.L[i].PCL,
                    sell_short: this._authServer.iQuote.getPlayerName(msg.quoteTrade.L[i].PCL) || msg.quoteTrade.L[i].PCL,
                    sellId: msg.quoteTrade.L[i].PCL,
                    going_for_growth: aggressor,
                    class: aggressorClass
                  };
                  if (data.buy_short.length > 5) {
                    data.buy_short = data.buy_short.substr(0, 4) + '...';
                  }
                  if (data.sell_short.length > 5) {
                    data.sell_short = data.sell_short.substr(0, 4) + '...';
                  }
                  this.rowOffersData.push(data);
                }
              }
            }
            AppUtils.orderObjectDesc(this.rowOffersData, 'time');
          }
        });
    } else {
      this.showEmpty = true;
    }
  }

  openNewWindow() {
    if (this.symbol) {
      const options = 'width=300px, height=498px';
      const parameters = '?symbol=' + this.symbol;

      if (this.windowActive == null || this.windowActive.closed) {
        super.getNewWindow('timestrades', parameters, options, this.data.id)
          .subscribe(window => {
            this.windowActive = window;
          });
      } else {
        this.windowActive.focus();
      }
    } else {
      this._NotificationService.warn('', Constants.WORKSPACE_MSG025);
    }
  }

  closeSheet() {
    if (this.windowActive != null) {
      this.windowActive.close();
    }
  }

  mouseEnterBrokerRow() {
    this.tooltiphover = true;

    setTimeout(() => {
      this.mouseLeaveBrokerRow();
    }, 8000);
  }

  mouseLeaveBrokerRow() {
    this.tooltiphover = false;
  }

}
